import Header from "../common/Header";
import bottomHero from "@/assets/images/bottom-hero-desktop.png";
import topHero from "@/assets/images/top-hero-desktop.png";
import ScrollToTop from "../common/ScrollToTop";

export default function DesktopLayout({
  children,
  showTopHero = true,
}: {
  children: React.ReactNode;
  showTopHero?: boolean;
}) {
  return (
    <div className="relative min-h-screen flex flex-col">
      {/* Shared background */}
      <div
        className="pointer-events-none absolute inset-0 z-0"
        aria-hidden="true"
      >
        {showTopHero && (
          <img
            src={topHero}
            alt=""
            className="absolute top-16 inset-x-0 w-full object-cover"
          />
        )}

        <img
          src={bottomHero}
          alt=""
          className="absolute inset-x-0 w-full object-cover"
          style={{ bottom: "var(--action-bar-height, 0px)" }}
        />
      </div>

      <ScrollToTop />
      {/* Header */}
      <Header />

      {/* Main content */}
      <main
        className="relative z-10 flex-1"
        style={{ paddingBottom: "var(--action-bar-height, 0px)" }}
      >
        {children}
      </main>
    </div>
  );
}
